<template>
    <div>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <router-link :to="{name:'home'}" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Not Found</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule">
            <div class="pt-2 pb-2 pl-3 pr-3">
                <div class="text-center mt-5 mb-5">
                    <img :src="require('@/assets/image/not_found.svg')" alt="Not Found" class="w-75 mb-3"><br>
                    <i>Halaman ini tidak tersedia</i>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    mounted(){
        document.body.classList.add('bg-white')
    },
    destroyed() {
        document.body.classList.remove('bg-white')
    },
}
</script>